/**
 * @COMMENT - 하드코딩 된 상수들을 분리하여 코드 유지보수성 향상
 * SVG 합성 관련 상수들
 */
export const SVG_COMPOSITE_CONSTANTS = {
  NAMESPACES: {
    SVG: 'http://www.w3.org/2000/svg',
    XLINK: 'http://www.w3.org/1999/xlink',
  },
  MATERIAL_TYPES: {
    OVERLAY: 'overlay' as const,
    MULTIPLY: 'multiply' as const,
  },
  SELECTORS: {
    CUT_PATH: 'path[stroke-dasharray], path',
    DESIGN_USE: 'use[href="#design-image-svg"], use[xlink\\:href="#design-image-svg"]',
    MATERIAL_GROUP: 'g[data-role="material-pass"]',
  },
  ATTRIBUTES: {
    STROKE_PROPS: [
      'stroke',
      'stroke-width',
      'stroke-linecap',
      'stroke-linejoin',
      'stroke-miterlimit',
      'stroke-dasharray',
      'stroke-dashoffset',
    ] as const,
  },
} as const;

/**
 * 필터 결과 이름 상수 (기본값)
 */
export const DEFAULT_FILTER_RESULTS = {
  MATERIAL: 'material',
  BLENDED: 'blended',
  FINAL: 'final',
} as const;
